import { EnterpriseLink, TruncatedText } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { Link, Typography } from '@optimus-web/core';
import { useDialog } from '@mews/framework';
import { LedgerAccountType } from '@mews-commander/data-access';
import { TEXT_LENGTH } from '../constants';
import { DeletedBillDialog } from '../DeletedBillDialog';
import { CompanyDetailTabs } from '../../../../companyDetail';

interface BillColumnProps {
    info: {
        row: {
            original: {
                billName?: string | null;
                billId?: string | null;
                ownerId?: string | null;
                billState?: string | null;
                ownerType?: LedgerAccountType | null;
            };
        };
    };
}
export const BillColumn = ({ info }: BillColumnProps) => {
    const { billName, billId, ownerId, billState, ownerType } = info.row.original;
    const [{ onClose, active }, toggleDialog] = useDialog();

    if (!billName || !billId) {
        return (
            <Typography data-test-id="no-bill-name" textStyle="bodyMedium" as="span">
                {UnicodeEntity.Dash}
            </Typography>
        );
    }
    switch (billState) {
        case 'Closed':
            return (
                <EnterpriseLink variant="basic" to="Bill/Detail/$id" params={{ id: billId || '' }}>
                    <TruncatedText text={billName} maxLength={TEXT_LENGTH} />
                </EnterpriseLink>
            );
        case 'Open':
            if (ownerType === LedgerAccountType.Customer) {
                return (
                    <EnterpriseLink
                        variant="basic"
                        to="Billing/Account/$accountId"
                        params={{ accountId: ownerId || '' }}
                    >
                        <TruncatedText text={billName} maxLength={TEXT_LENGTH} />
                    </EnterpriseLink>
                );
            }
            return (
                <EnterpriseLink
                    variant="basic"
                    to="Company/Detail/$id"
                    params={{ id: ownerId || '' }}
                    search={{ tab: CompanyDetailTabs.Billing }}
                >
                    <TruncatedText text={billName} maxLength={TEXT_LENGTH} />
                </EnterpriseLink>
            );
        case null:
            return (
                <>
                    <Link onClick={toggleDialog} variant="basic" as="button">
                        <TruncatedText text={billName} maxLength={TEXT_LENGTH} />
                    </Link>
                    <DeletedBillDialog active={active} onClose={onClose} />
                </>
            );
        default:
            return (
                <Typography data-test-id="no-bill-name" textStyle="bodyMedium" as="span">
                    {UnicodeEntity.Dash}
                </Typography>
            );
    }
};
